<template>
  <div class="h-full w-full">
    <header
      :class="[
        'w-full fixed z-10 bg-white',
        isScrolled ? 'shadow-md' : 'shadow-none',
      ]"
    >
      <div
        class="flex justify-between px-6 md:px-24 items-center"
        @click.self="closeMenus"
      >
        <!-- Logo -->
        <a class="text-[28px] md:text-[55px] py-2 left-5" href="/">
          Núria Jordán
        </a>

        <!-- Botón Hamburguesa -->
        <button
          class="md:hidden flex items-center text-lg focus:outline-none"
          @click="toggleMobileMenu"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            class="w-8 h-8"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              :d="
                isMobileMenuOpen
                  ? 'M6 18L18 6M6 6l12 12'
                  : 'M4 6h16M4 12h16M4 18h16'
              "
            />
          </svg>
        </button>

        <!-- Menú principal -->
        <div
          class="hidden md:flex gap-8"
          :class="{ block: !isMobileMenuOpen, hidden: isMobileMenuOpen }"
        >
          <!-- Projectes con submenú en desktop -->
          <div class="relative group">
            <ul>
              <a href="/projects" class="cursor-pointer">
                <li
                  class="text-lg cursor-pointer hover:underline underline-offset-4"
                >
                  Projectes
                </li>
              </a>
            </ul>
            <ul
              class="absolute left-0 transform -translate-x-1/3 bg-white shadow-lg rounded-lg py-2 text-center w-48 z-20 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity duration-300"
            >
              <li class="py-1 hover:bg-gray-200 cursor-pointer">
                <a href="/prova"> L'anòmala</a>
              </li>
              <li class="py-1 hover:bg-gray-200 cursor-pointer">
                <a href="/modern"> El Modern </a>
              </li>
              <li class="py-1 hover:bg-gray-200 cursor-pointer">
                <a href="/wildtech"> Wildtech </a>
              </li>
              <li class="py-1 hover:bg-gray-200 cursor-pointer">
                <a href="/sense"> Sense </a>
              </li>
              <li class="py-1 hover:bg-gray-200 cursor-pointer">
                <a href="/broomx"> Broomx </a>
              </li>
              <li class="py-1 hover:bg-gray-200 cursor-pointer">
                <a href="/units"> Units x Educar </a>
              </li>
            </ul>
          </div>

          <!-- Sobre mi -->
          <div class="relative">
            <p
              class="text-lg cursor-pointer hover:underline underline-offset-4"
            >
              <a href="/presentacio"> Sobre mi </a>
            </p>
          </div>
        </div>

        <!-- Menú móvil -->
        <div
          class="absolute top-full left-0 w-full bg-white shadow-md md:hidden"
          v-show="isMobileMenuOpen"
        >
          <ul class="flex flex-col items-center py-4 space-y-4">
            <!-- Projectes sin submenú en móvil -->
            <li>
              <a href="/projects" class="text-lg">Projectes</a>
            </li>
            <!-- Sobre mi -->
            <li>
              <a href="/presentacio" class="text-lg">Sobre mi</a>
            </li>
          </ul>
        </div>
      </div>
    </header>
    <div class="w-full h-full">
      <div
        class="w-full h-full flex flex-col items-center text-center justify-center gap-4"
      >
        <h1 class="text-2xl font-bold">L'Anòmala</h1>
        <p class="w-[40%] text-lg">
          El projecte transmèdia L’Anòmala neix de la col·laboració de set
          estudiants com a treball de fi de carrera. Es tracta d’una
          instal·lació interactiva que busca generar una experiència
          gastronòmica on els usuaris qüestionin la seva manera de menjar a
          través d’un àpat ple de provocacions. Ens hem encarregat de tot el
          procés, des de la concepció fins a l’execució de l’experiència. El meu
          paper en aquest projecte ha estat assumir la direcció i desenvolupar
          tota la infraestructura digital.
        </p>
      </div>
      <div class="flex flex-col gap-12 pb-20">
        <div class="flex justify-center">
          <img
            src="/img/anomala/anomala1.png"
            alt="Fotografia de l'instal·lació de l'Anòmala."
            class="w-[60%]"
          />
        </div>
        <div class="flex justify-center">
          <img
            src="/img/anomala/anomala2.png"
            alt="Un servei de l'experiència. "
            class="w-[60%]"
          />
        </div>
        <div class="flex justify-center">
          <img
            src="/img/anomala/anomala3.png"
            alt="Fotografia de com era la sala de control."
            class="w-[60%]"
          />
        </div>
        <div class="flex justify-center">
          <img
            src="/img/anomala/anomala5.JPG"
            alt="Taula de l'experiència"
            class="w-[60%]"
          />
        </div>
        <div class="flex justify-center">
          <img
            src="/img/anomala/anomala4.png"
            alt="Sala de control"
            class="w-[60%]"
          />
        </div>
        <div class="flex justify-center">
          <img
            src="/img/anomala/anomala6.JPG"
            alt="Dies de montatge."
            class="w-[60%]"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      projectsVisible: false,
      isVisible: false,
      isScrolled: false,
      isMobileMenuOpen: false,
    };
  },
  methods: {
    toggleProjects() {
      this.projectsVisible = !this.projectsVisible;
      this.isVisible = false;
    },
    toggleInfo() {
      this.isVisible = !this.isVisible;
      this.projectsVisible = false;
    },
    closeMenus() {
      this.projectsVisible = false;
      this.isVisible = false;
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 200;
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    closeMobile() {
      this.isMobileMenuOpen = false;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style>
.background-variable {
  background-color: var(--background-color);
}
</style>

